import React from 'react'
import { SideDrawerForm } from '@sales-center/components'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import { LeadAssignmentRuleFormModel } from '@user/components/Settings/LeadAssignmentRule/LeadAssignmentRuleForm/typings'
import { useData } from './hooks/useData'
import { ConditionItem } from '@user/components/Settings/LeadAssignmentRule/LeadAssignmentRuleForm/FormFields/Conditions/ConditionsList/ConditionViewItem'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
interface Props {
  onClose: () => void
  onEdit: () => void
  assignment: LeadAssignmentRuleFormModel
}

export function LeadAssignmentRuleDrawer(props: Props) {
  const { onClose, assignment, onEdit } = props
  const {
    name,
    description,
    assignmentRuleConditions,
    salesFunnelId,
    salesTeamIds,
    ownerIds,
    leadStatusId,
  } = assignment
  const { salesFunnel, stage, salesTeams, owners } = useData(
    salesFunnelId,
    leadStatusId,
    salesTeamIds,
    ownerIds,
  )

  return (
    <SideDrawerForm
      onCancel={onClose}
      cancelBtnVariant={'text'}
      secondaryBtnLabel={'Close'}
      noTextTransform
    >
      <Stack p={2}>
        <Typography variant="h7" mb={1}>
          Name
        </Typography>
        <Typography variant="subtitle3">{name}</Typography>
        <Typography variant="body1">{description}</Typography>

        <Typography variant="h7" mt={4} mb={1}>
          {assignmentRuleConditions.length}
          {assignmentRuleConditions.length == 1
            ? ' Condition '
            : ' Conditions '}{' '}
          Created
        </Typography>
        <Typography variant="body1" mb={2}>
          All conditions below are used to automatically assign an owner when a
          new lead is created.{' '}
        </Typography>

        <Divider />

        <Stack>
          {assignmentRuleConditions.map((condition, idx) => (
            <ConditionItem
              data={condition}
              key={`condition_${idx}`}
              idx={idx}
            />
          ))}
        </Stack>

        <Typography variant="h7" mt={4} mb={1}>
          Sales Ownership
        </Typography>

        <Typography variant="subtitle3">Sales Teams</Typography>
        <Box mb={1}>
          {salesTeams.map((team, idx) => {
            return (
              <Typography key={idx} variant="body1">
                {team.name}
              </Typography>
            )
          })}
        </Box>

        <Typography variant="subtitle3">Owners</Typography>
        <Box mb={1}>
          {owners.map((owner, idx) => {
            return (
              <Typography key={idx} variant="body1">
                {owner?.name}
              </Typography>
            )
          })}
        </Box>

        <Typography variant="subtitle3">Sales Funnel</Typography>
        <Typography variant="body1" mb={1}>
          {salesFunnel}
        </Typography>

        <Typography variant="subtitle3">Lead Status</Typography>
        <Typography variant="body1">{stage}</Typography>
      </Stack>

      <Button
        variant={'text'}
        onClick={onEdit}
        size="large"
        sx={{
          paddingX: 2,
          justifyContent: 'start',
          mb: 2,
          textTransform: 'none',
        }}
      >
        Edit Assignment Rule
      </Button>
    </SideDrawerForm>
  )
}
